import React from 'react';
import PropTypes from 'prop-types';
import {Typography, Alert} from '@mui/material';
import { connect } from 'react-redux';


const Alerta = ({ alerts = [] }) => {
  return alerts !== null && alerts.length > 0 && alerts.map(alert => {
    return(
      <Alert className="mss-alert" key={alert.id} severity="error">
        <Typography component="p" color="error">{alert.msg}</Typography>
      </Alert>
    )
  });
}

Alerta.propTypes = {
  alerts: PropTypes.array
}

const mapStateToProps = state => ({
  alerts: state.alert
});

export default connect(mapStateToProps)(Alerta);